"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFunctions = void 0;
const Sentry_1 = require("../utils/Sentry/Sentry");
var CustomFunctions;
(function (CustomFunctions) {
    class controlFunctions {
        static copyToClipBoard(str, onSuccess) {
            navigator.clipboard.writeText(str).then(() => { if (onSuccess) {
                onSuccess();
            } })
                .catch((reason) => {
                console.error('Impossible to copy text', reason);
                (0, Sentry_1.SentryReportCustomError)('Impossible to copy text');
            });
        }
        ;
    }
    CustomFunctions.controlFunctions = controlFunctions;
})(CustomFunctions || (exports.CustomFunctions = CustomFunctions = {}));
